export default __webpack_public_path__ + "static/media/011-fishing.c756327e.png";